module.exports = __webpack_public_path__ + "static/media/display-suite-10.2dbc2fb1.jpg";